import { render, staticRenderFns } from "./AS_WebsitePolicy.vue?vue&type=template&id=6887cd12&scoped=true&"
import script from "./AS_WebsitePolicy.vue?vue&type=script&lang=js&"
export * from "./AS_WebsitePolicy.vue?vue&type=script&lang=js&"
import style0 from "./AS_WebsitePolicy.vue?vue&type=style&index=0&id=6887cd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887cd12",
  null
  
)

export default component.exports